// extracted by mini-css-extract-plugin
export default {"logo":"CreditCardPreview_logo__mYCSO"};